<template>
  <div class="calendar">
    <v-row justify="center">
      <v-col class="pb-0" cols="12" align="center">
        <div class='mt-5 mb-2 title d-flex justify-center'>
          <span><v-img width="30px" :src='schoolLogoUrl' /></span>
          <span v-if="$i18n.locale=='tc'" class='ml-2'> {{ schoolChiName }} </span>
          <span v-else class='ml-2'> {{ schoolName }} </span>
        </div>
      </v-col>
      <v-col class="mx-3" align="center">
        <v-sheet max-width="1200px">
          <v-select v-if="$i18n.locale=='tc'"
            :items="api.experiments"
            item-text="experiment_set_chi"
            item-value="experiment_set"
            v-model="selected_experiment"
            label="請選擇實驗組"
            no-data-text="沒有適用的實驗組"
            @change="changeExperimentSet(selected_experiment);"
          ></v-select>
          <v-select v-else
            :items="api.experiments"
            item-text="experiment_set"
            item-value="experiment_set"
            v-model="selected_experiment"
            label="Select an experiment set"
            no-data-text="No Experiment Available"
            @change="changeExperimentSet(selected_experiment);"
          ></v-select>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col class="py-0" cols="12" align="center">
        <v-sheet heigth="64px" max-width="1200px">
          <v-toolbar flat>
            <v-btn fab text small color="grey darken-2" @click="$refs.calendar.prev()">
              <v-icon>
                mdi-chevron-left
              </v-icon>
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="$refs.calendar.next()">
              <v-icon>
                mdi-chevron-right
              </v-icon>
            </v-btn><v-btn outlined class="mr-4" color="grey darken-2" @click="setToday" :disabled="focus==''">
              {{ $t("booking.calendar.today") }}
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-chip class="ma-2" label dark color="green">{{ $t("booking.calendar.tip_reserved") }}</v-chip>
            <v-chip class="ma-2 px-5" label dark color="grey">{{ $t("booking.calendar.tip_suspended") }}</v-chip>
            <v-chip class="ma-2" label dark color="amber darken-2">{{ $t("booking.calendar.tip_maintenance") }}</v-chip>
          </v-toolbar>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row>
      <v-col col=12 align="center">
        <v-sheet max-width="1200px">
          <v-calendar              
            ref="calendar"
            v-model="focus"
            :weekdays=weekday
            type="week"
            :locale="localeArr[$i18n.locale]"
            :interval-format="intervalFormat"
            :events="events"
            event-overlap-mode="column"
            :event-overlap-threshold="30"
            :event-color="getEventColor"
            @click:event="showEvent"
            @click:more="viewDay"
            @click:date="viewDay"
            @change="getEvents"
          >
          <template v-slot:event="{ event }">
            {{event.name}}
            <br>
            {{ event.start_time }} - {{ event.end_time }}
          </template>
          </v-calendar>
          <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x>
            <v-card color="grey lighten-4" min-width="350px" flat>
              <v-toolbar :color="selectedEvent.color" dark>
                <v-btn icon @click="selectedOpen = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title class="pl-0">{{ selectedEvent.name }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <span v-if="user.user_level=='ADMIN' || user.user_level=='INCHARGE'"  v-html="selectedEvent.details"></span>
                <span v-else-if="user.user_level=='USER'"  v-html="selectedEvent.details_users"></span>
              </v-card-text>
            </v-card>
          </v-menu>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { api_management } from "@/services/iot/api_management";
import { api_booking } from "@/services/iot/api_booking";
import moment from 'moment';
const apiManagement = new api_management(process.env.VUE_APP_BASE_URL);
const apiBooking = new api_booking(process.env.VUE_APP_BASE_URL);
export default {
  props: ["schoolName", "schoolChiName", "schoolLogoUrl"],
  name: "Calendar",
  data: function () {
    return {
      user: {
        user_level: "",
        username: "",
      },
      localeArr: {"tc": 'zh-hk', "en": 'en'},
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      focus: '',
      type: 'month',
      mode: 'stack',
      weekday: [0, 1, 2, 3, 4, 5, 6],
      events: [],
      color_index:['RESERVED', 'SUSPENDED', 'MAINTENANCE', 'PASSED'],
      colors: ['green', 'grey', 'amber darken-2'],
      colors_passed: ['green lighten-4', 'grey lighten-2', 'amber lighten-3'],
      slots:[],
      api:{
        experiments:[],
      },
      calendar: {
        start: {},
        end: {},
      },
      school_id: "",
      experiment: "All",
      equipment_id: "All",
      selected_experiment: "All - All",
      show_all: false,
      setTranslate: {
        "set_1": "裝置1",
        "set_2": "裝置2",
        "set_3": "裝置3",
        "set_4": "裝置4",
        "set_5": "裝置5",
        "set_6": "裝置6",
        "set_7": "裝置7",
        "set_8": "裝置8",
        "set_9": "裝置9",
        "裝置1": "set_1",
        "裝置2": "set_2",
        "裝置3": "set_3",
        "裝置4": "set_4",
        "裝置5": "set_5",
        "裝置6": "set_6",
        "裝置7": "set_7",
        "裝置8": "set_9",
      },
      experimentNameTranslate: {
        "apparent_depth": "表觀深度",
        "em_induction": "電磁感應",
        "interference": "干涉現象",
        "photoelectric": "光電效應",
        "ultrasound": "超聲波成像",
        "radiation": "幅射",
        "visible_spectrum": "可見光光譜",
        "emission_spectrum": "發射光譜",
        "titration": "滴定法",
        "identify_unknown_anion": "辨識未知負離子",
        "kinetic_rate": "化學反應速率",
        "spectrophotometry": "分光光度法",
        "bacteria_growth": "細菌生長",
        "greenhouse": "溫室效應",
        "iodine_test": "碘測試",
        "photosynthesis": "光合作用",
        "respiration": "呼吸作用",
        "tensile_test": "拉伸試驗",
        "capacitance": "電容",
        "air_monitoring": "空氣監測",
        "表觀深度": "APPARENT_DEPTH",
        "電磁感應": "EM_INDUCTION",
        "干涉現象": "INTERFERENCE",
        "光電效應": "PHOHOELECTRIC",
        "超聲波成像": "ULTRASOUND",
        "幅射": "RADIATION",
        "可見光光譜": "VISIBLE_SPECTRUM",
        "發射光譜": "EMISSION_SPECTRUM",
        "滴定法": "TITRATION",
        "辨識未知負離子": "IDENTIFY_UNKNOWN_ANION",
        "化學反應速率": "KINETIC_RATE",
        "分光光度法": "SPECTROPHOTOMETRY",
        "細菌生長": "BACTERIA_GROWTH",
        "溫室效應": "GREENHOUSE_GASES",
        "碘測試": "IODINE_TEST",
        "光合作用": "PHOTOSYNTHESIS",
        "呼吸作用": "RESPIRATION",
        "拉伸試驗": "TENSILE_TEST",
        "電容": "CAPACITANCE",
        "空氣監測": "AIR_MONITORING"
      }
    };
  },
  mounted: function () {
    var self = this;
    self.school_id = self.$route.params.school_id;
    self.user.user_level = self.$cookies.get("user_level");
    self.user.username = self.$cookies.get("username");
    if( self.user.user_level=="INCHARGE" ||  self.user.user_level=="ADMIN" ){
      self.show_all = true;
    }
    else {
      self.show_all = false;
    }
    self.getSchoolOpenedExperiment();
    
      self.selected_experiment = "All - All";
  },  
  computed: {
    
  },
  methods: {    
    getSchoolOpenedExperiment(){
      var self = this;
      apiManagement.getSchoolOpenedExperiment(self.school_id, self.show_all)
      .then((response) => {          
          self.api.experiments = response.experiments;
          self.api.experiments.unshift(
            {
              "school": self.school_id,
              "experiment": "All",
              "experiment_chi": "全部",
              "equipment_id": "All",
              "equipment_id_chi": "全部",
              "experiment_set": "All - All",
              "experiment_set_chi": "全部 - 全部"
            }
          )
      });
    },
    changeExperimentSet(experiment_set){
      var self = this;
      let split = experiment_set.split(" - ");
      self.experiment = split[0];
      self.equipment_id = split[1];
      self.getEvents(self.calendar);
      
      self.$refs.calendar.checkChange()
    },
    intervalFormat(interval) {
      return interval.time;
    },
    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'
    },
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    getEvents ({ start, end }) {
      var self = this;
      console.log(start, end);
        self.calendar.start = start;
        self.calendar.end = end;
        console.log(self.calendar.start, self.calendar.end);
        const events = [];        
        const min = new Date(`${start.date}T00:00:00`)
        const max = new Date(`${end.date}T23:59:59`)
        console.log(min, max);
        let experiment = self.experiment;
        let equipment_id = self.equipment_id;
        apiManagement.getWeekBookings(self.$route.params.school_id, experiment, equipment_id, min, max)
        .then((response) => {
          if (response.status == "success") {
            for (let i = 0; i < response.bookings.length; i++) {
              let booking = response.bookings[i];
              let has_entered = "";
              if(booking.has_entered == "1"){
                has_entered = "Y";
              }
              let color = "";
              if(booking.passed==true){
                color=self.colors_passed[self.color_index.indexOf(booking.status)]
              }
              else {
                color=self.colors[self.color_index.indexOf(booking.status)]
              }
              if(self.$i18n.locale=="tc"){
                events.push({
                  name: booking.experiment_set_chi,
                  start: booking.start_at,
                  end: booking.end_at,
                  color: color,
                  start_time: moment(booking.start_at).format('HH:mm'),
                  end_time: moment(booking.end_at).format('HH:mm'),
                  details_users:
                  "<table>\
                    <tr><td>實驗裝置:&nbsp</td><td>"+booking.experiment_set_chi+"</td></tr>\
                    <tr><td>開始:&nbsp</td><td>"+booking.start_at+"</td></tr>\
                    <tr><td>結束:&nbsp</td><td>"+booking.end_at+"</td></tr>\
                    <tr><td>狀態:&nbsp</td><td>"+booking.status_chi+"</td></tr>\
                  </table>",
                  details: 
                  "<table>\
                    <tr><td>使用者:&nbsp</td><td>"+booking.username+"</td></tr>\
                    <tr><td>實驗裝置:&nbsp</td><td>"+booking.experiment_set_chi+"</td></tr>\
                    <tr><td>開始:&nbsp</td><td>"+booking.start_at+"</td></tr>\
                    <tr><td>結束:&nbsp</td><td>"+booking.end_at+"</td></tr>\
                    <tr><td>狀態:&nbsp</td><td>"+booking.status_chi+"</td></tr>\
                    <tr><td>已進入:&nbsp</td><td>"+has_entered+"</td></tr>\
                  </table>"
                })
              }else {
                events.push({
                  name: booking.experiment_set,
                  start: booking.start_at,
                  end: booking.end_at,
                  color: color,
                  start_time: moment(booking.start_at).format('HH:mm'),
                  end_time: moment(booking.end_at).format('HH:mm'),                  
                  details_users:
                  "<table>\
                    <tr><td>Experiment Set:&nbsp</td><td>"+booking.experiment_set+"</td></tr>\
                    <tr><td>From:&nbsp</td><td>"+booking.start_at+"</td></tr>\
                    <tr><td>To:&nbsp</td><td>"+booking.end_at+"</td></tr>\
                    <tr><td>Status:&nbsp</td><td>"+booking.status+"</td></tr>\
                  </table>",
                  details: 
                  "<table>\
                    <tr><td>User:&nbsp</td><td>"+booking.username+"</td></tr>\
                    <tr><td>Experiment Set:&nbsp</td><td>"+booking.experiment_set+"</td></tr>\
                    <tr><td>From:&nbsp</td><td>"+booking.start_at+"</td></tr>\
                    <tr><td>To:&nbsp</td><td>"+booking.end_at+"</td></tr>\
                    <tr><td>Status:&nbsp</td><td>"+booking.status+"</td></tr>\
                    <tr><td>已進入:&nbsp</td><td>"+has_entered+"</td></tr>\
                  </table>"
                })
              }
            }
            self.events = events;
          } else {
            self.events = [];
            //alert(response.message+"asda");
          }
        });        
      },
      getEventColor (event) {
        return event.color
      },
      rnd (a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
      },
      setToday () {
        this.focus = ''
      },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
</style>